var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left text-dark col"},[_c('FormularioLibro',{attrs:{"firebase":_vm.firebase,"editar":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }